<template>
   <div class="progress-group-item" v-if="value" :class="{ error }">
      <p class="title">{{ title }}</p>
      <p class="value"><slot></slot></p>

      <button class="action" type="button" @click="$emit('click')">Change</button>
   </div>
</template>

<script>
export default {
  name: 'ProgressGroupItem',
  props: {
    title: String,
    value: String | Number,
    error: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
    .progress-group-item {
       position: relative;
       border-bottom: 1px solid #e6e6e6;
       padding: 7px 65px 5px 0;

       &:before {
          opacity: 0;
          content: '';
          position: absolute;
          left: -10px;
          top: 0;
          height: 100%;
          width: 4px;
          border-radius: 2px;
          background-color: $form-border-colour--error;
       }

       > .action {
          position: absolute;
          right: 0;
          top: 0;
          height: 100%;
          font-size: 13px;
          font-weight: 700;
          border: none;
          color: $brand-colour-primary;
          background-color: transparent;

          &:hover {
             text-decoration: underline;
          }
       }

       > .title {
          font-size: 10px;
          font-weight: 300;
          color: #676767;
          margin: 0;
          font-weight: 700;
       }

       > .value {
          font-size: 13px;
          color: #676767;
          margin: 0;
       }

       &.error:before {
          opacity: 1;
       }
    }
</style>
